'use client';
import React from 'react';

export default function HeroShapes() {
  const shapes = [
    { top: '15%', right: '8%', size: 80, delay: '0s', opacity: 0.12 },
    { top: '35%', right: '20%', size: 50, delay: '2s', opacity: 0.08 },
    { top: '65%', right: '5%', size: 60, delay: '1s', opacity: 0.1 },
    { top: '20%', right: '35%', size: 30, delay: '3s', opacity: 0.07 },
    { top: '75%', right: '28%', size: 40, delay: '0.5s', opacity: 0.09 },
  ];

  return (
    <>
      {shapes?.map((s, i) => (
        <div
          key={`shape-${i}`}
          className="absolute pointer-events-none hidden lg:block"
          style={{
            top: s?.top,
            right: s?.right,
            width: s?.size,
            height: s?.size,
            opacity: s?.opacity,
            animationDelay: s?.delay,
            animation: `float 6s ease-in-out ${s?.delay} infinite`,
          }}
        >
          <svg
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-full"
          >
            <path
              d="M40 5 C20 5 5 20 5 40 C5 55 15 68 30 73 C28 60 32 45 40 35 C48 45 52 60 50 73 C65 68 75 55 75 40 C75 20 60 5 40 5Z"
              fill="#16a34a"
            />
            <line
              x1="40"
              y1="73"
              x2="40"
              y2="80"
              stroke="#16a34a"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </svg>
        </div>
      ))}
    </>
  );
}